<template>
    <div id="intro">
        <p v-for="content in introContent">
            {{ content }}
        </p>
    </div>
</template>

<script>
    export default {
        name: 'ContactUsIntro',
        data() {
            return {
                introContent: [
                    'Precisando de ajuda? Conte conosco!',
                    'Nosso horário de atendimento online é de segunda a sexta, das 8:00 às 18:00. As mensagens enviadas fora deste horário serão respondidas em até 3 dias úteis.',
                ],
            };
        },
    };
</script>
